module.exports = __webpack_public_path__ + "static/2-0a91f31e20dae56b3b8951d3dc599a0b.jpg";